<template>
    <div>
        <proposalSeriesNames/>
    </div>
</template>

<script>
    import ProposalSeriesNames from './name/index.vue'
    
    export default {
        name: 'proposal-series',

        components:{
            ProposalSeriesNames
        }
    }

</script>